<button
  [ngClass]="{
    'button-green':
      status == surveyStatus.OutsideDone || status == surveyStatus.InsideDone,
    'button-black': status == surveyStatus.OutsideOnGoing,
    'button-red': status == surveyStatus.OutsideWaitingForValidation,
    'button-InsideOngoing': status == surveyStatus.InsideOnGoing,
    'button-InsideWaiting': status == surveyStatus.InsideWaitingForValidation,
    'button-blue': status == surveyStatus.OutsidePending,
    'button-InsidePending': status == surveyStatus.InsidePending,
    'button-IsPrefill': status == surveyStatus.Prefill,
    abbreviate: abbreviate
  }"
>
  {{ statusString }}
</button>
